import React from 'react';
import ClinicImage from '../../../images/clinicImages/clinicImage.jpg'
import PrimaryButton from '../../Buttons/PrimaryButton'
import { useLocation } from "react-router-dom";

function InfoWindowComponent({ name, address, postalCode, city, country, type, setSelectedClinic, setCurrentStep, id, email, phone}) {

  
  const clinic = {
    name: name,
    address: address,
    postalCode: postalCode,
    city: city,
    country: country,
    id: id,
    type: type,
    email: email,
    phone: phone
  }

  const selectClinic = (clinic) => {
    setSelectedClinic(clinic)
    setCurrentStep("3")
  }

  return (
    <div className="flex flex-col w-40 lg:w-80 overflow-none pl-1.5">
      <div className="overflow-none pb-4">
        <div className="flex items-center mb-2">
          <h1 className="font-semibold text-lg">{name} -</h1>
          <p className="ml-2 px-0.5 text-lg">{type}</p>
        </div>
        <p className="text-base pb-0.5">{address}, {postalCode}</p>
        <p className="text-base">{phone}</p>
      </div>
      <div className="">
        {window.location.pathname.includes("/scanandgo") && <PrimaryButton text="Choose Clinic" onClick={() => selectClinic(clinic)}/>}
      </div>
    </div>
  )
}

export default InfoWindowComponent;
